/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_Deleting_Transcript_FileInputs */

const en_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error deleting transcript file. ${i?.error}`)
};

const fr_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de la suppression du fichier de transcription. ${i?.error}`)
};

const de_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Löschen der Protokolldatei. ${i?.error}`)
};

const it_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'eliminazione del file di trascrizione. ${i?.error}`)
};

const ru_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при удалении файла стенограммы. ${i?.error}`)
};

const es_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al eliminar el archivo de transcripción. ${i?.error}`)
};

const zh_cn2_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除成绩单文件时出错。${i?.error}`)
};

const ja_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トランスクリプトファイルの削除中にエラーが発生しました。${i?.error}`)
};

const hi_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्ट फ़ाइल को हटाने में त्रुटि। ${i?.error}`)
};

const pt_pt2_error_deleting_transcript_file = /** @type {(inputs: Error_Deleting_Transcript_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao excluir o arquivo de transcrição. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error deleting transcript file. {error}" |
*
* @param {Error_Deleting_Transcript_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_deleting_transcript_file = /** @type {((inputs: Error_Deleting_Transcript_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Deleting_Transcript_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_deleting_transcript_file(inputs)
	if (locale === "de") return de_error_deleting_transcript_file(inputs)
	if (locale === "it") return it_error_deleting_transcript_file(inputs)
	if (locale === "ru") return ru_error_deleting_transcript_file(inputs)
	if (locale === "es") return es_error_deleting_transcript_file(inputs)
	if (locale === "zh-CN") return zh_cn2_error_deleting_transcript_file(inputs)
	if (locale === "ja") return ja_error_deleting_transcript_file(inputs)
	if (locale === "hi") return hi_error_deleting_transcript_file(inputs)
	if (locale === "pt-PT") return pt_pt2_error_deleting_transcript_file(inputs)
	return en_error_deleting_transcript_file(inputs)
});